import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import AuthenticatedRoute from './AuthenticatedRoute';
import App from '../components/App';

import Patients from '../components/Patients';
import Dashboard from '../components/Dashboard';
import AddTCode from '../components/AddTCode';
import JourneyDetail from '../components/JourneyDetail';
import JourneyMaster from '../components/JourneyMaster';
import DoctorAlert from '../components/DoctorAlert';
import AdminDoctor from '../components/AdminDoctor';
import RegisterDoctor from '../components/RegisterDoctor';
import CreateNewDoctor from '../components/CreateNewDoctor';
import EditDoctor from '../components/EditDoctor';
import ArchivedPatients from '../components/ArchivedPatients';
import AppJLog from '../components/AppJLog';
import AppJGraph from '../components/AppJGraph';
import DrillDownReport from '../components/DrillDownReport';

import FaxSend2 from '../components/FaxSend2';
import ContentManagement from '../components/ContentManagement';
import LifeLineManagement from '../components/LifeLineManagement';
import AdminFax from '../components/AdminFax';
import Hl7Logs from '../components/Hl7Logs';
import ActReport from '../components/ActReport';
import EncounterReport from '../components/EncounterReport';
import ReviewReport from '../components/ReviewReport';
import ExternalFaxSend2 from '../components/ExternalFaxSend2';
import Groups from '../components/Groups';
import AutoAddTCode from '../components/AutoAddTCode';
import MessageTemplates from '../components/MessageTemplates';
import AdminManageReviewers from '../components/AdminManageReviewers';
import Pendingusers from '../components/Pendingusers';
import Cluster from '../components/Cluster';

import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import '../assets/scss/main.scss';
import AutoAddTCodeBP from '../components/AutoAddTCodeBP';

const Root = () => {
  return (
    <HashRouter basename="/docportal">
      <Switch>
        <Route path="/jlog/:device_id" component={AppJLog} />
        <Route path="/showChart/:tcode" component={AppJGraph} />
        <AuthenticatedRoute path="/add-new-patients/:TID" component={AddTCode} />
        <AuthenticatedRoute path="/add-new-patients" component={AddTCode} />
        <AuthenticatedRoute path="/edit_guard_rail/:TID" component={AddTCode} />
        <AuthenticatedRoute path="/adminDoctor" component={AdminDoctor} />
        <AuthenticatedRoute path="/groups" component={Groups} isAdminPage={true} />
        <AuthenticatedRoute path="/messageTemplates" component={MessageTemplates} isAdminPage={true} />
        <AuthenticatedRoute path="/alerts" component={DoctorAlert} />
        <AuthenticatedRoute path="/patients" component={Patients} />
        <AuthenticatedRoute path="/archivedPatients" component={ArchivedPatients} />
        <AuthenticatedRoute path="/dashboard" component={Dashboard} />
        <AuthenticatedRoute
          path="/JourneyDetail/:id"
          component={(props) => <JourneyDetail key={props.match.params.id} {...props} />}
        />
        <AuthenticatedRoute path="/JourneyMaster" component={JourneyMaster} />
        <AuthenticatedRoute
          path="/RegisterDoctor"
          component={(props) => <RegisterDoctor mode="NORMAL" {...props} />}
          isAdminPage={true}
        />
        <AuthenticatedRoute
          path="/ArchivedDoctors"
          component={(props) => <RegisterDoctor mode="ARCHIVED" {...props} />}
          isAdminPage={true}
        />
        <AuthenticatedRoute path="/CreateNewDoctor" component={CreateNewDoctor} isAdminPage={true} />
        <AuthenticatedRoute path="/editDoctor" component={EditDoctor} isAdminPage={true} />
        <AuthenticatedRoute path="/ActivityReport" component={DrillDownReport} isAdminPage={true} />
        <Route path="/getFaxReport/:PMHID" component={FaxSend2} />
        <Route path="/getExternalFaxReport/:PMHID" component={ExternalFaxSend2} />
        <AuthenticatedRoute path="/ContentManagement" component={ContentManagement} isAdminPage={true} />
        <AuthenticatedRoute path="/LifelineManagement" component={LifeLineManagement} isAdminPage={true} />
        <AuthenticatedRoute path="/faxes" component={AdminFax} isAdminPage={true} />
        <AuthenticatedRoute path="/hl7logs" component={Hl7Logs} />
        <AuthenticatedRoute path="/actreport" component={ActReport} />
        <AuthenticatedRoute path="/hl7Review" component={EncounterReport} />
        <AuthenticatedRoute path="/newhl7Review" component={ReviewReport} />
        <Route path="/auto_add_tcode/:clubID/:deviceId/:DID/:JID" component={AutoAddTCode} />
        <Route path="/auto_add_tcodeBP/:clubID/:deviceId/:DID/:JID" component={AutoAddTCodeBP} />
        <AuthenticatedRoute path="/reviewerManager" component={AdminManageReviewers} isAdminPage={true} />
        <AuthenticatedRoute path="/pendingusers" component={Pendingusers} />
        <AuthenticatedRoute path="/clusters" component={Cluster} isAdminPage={true} />
        <Route exact path="/" component={App} />
      </Switch>
    </HashRouter>
  );
};

export default Root;
